const menuAboutIT = {
    "view": {
        "label": {
            "myProfile": "Il Mio Profilo",
            "twoFactorAuthentication": "Autenticazione a Due Fattori",
            "mySubscription": "Il Mio Abbonamento",
            "announcements": "Avvisi",
            "mySubUsers": "I Miei Sotto-Utenti",
            "myLabels": "Le Mie Etichette",
            "escrowWallet": "Portafoglio Escrow",
            "copyright": "Violazioni del Copyright",
            "financialStatements": "Bilanci Finanziari",
            "userStatements": "Dichiarazioni Utente",
            "subuserStatements": "Dichiarazioni Sotto-Utente",
            "invoices": "Fatture",
            "paymentMethods": "Metodi di Pagamento",
            "purchaseHistory": "Cronologia Acquisti",
            "accessKeys": "Chiavi di Accesso",
            "logout": "Disconnetti"
        }
    }
};

export default menuAboutIT;